import { AppointmentStatusHistoryEnum } from '../graphql/generated/hasura';

export const APPOINTMENT_STATUS_HISTORY_LABELS: Record<string, string> = {
  [AppointmentStatusHistoryEnum.BookedNotPaid]: 'Booked. Not paid',
  [AppointmentStatusHistoryEnum.Upcoming]: 'Upcoming',
  [AppointmentStatusHistoryEnum.Completed]: 'Completed',
  [AppointmentStatusHistoryEnum.CompletedSummaryReady]: 'Summary Ready',
  [AppointmentStatusHistoryEnum.Canceled]: 'Canceled',
  [AppointmentStatusHistoryEnum.PatientMissed]: 'Patient Missed',
  [AppointmentStatusHistoryEnum.ProviderMissed]: 'Provider Missed',
  [AppointmentStatusHistoryEnum.NoShow]: 'Noshow',
};
